export default {
  slug: "tooth-replacement-in-guwahati",
  title: "Dental Crowns and Bridges in Guwahati",
  subtitle:
    "Restore Your Smile with Strength & Beauty – Natural-looking, durable solutions for damaged or missing teeth",

  heroImage:
    "/dental-services/crowns-and-bridges/best-dental-clinic-near-me.webp",

  sections: [
    {
      type: "text",
      heading: "Dental Crowns and Bridges in Guwahati",
      content: `
Missing, damaged, or weak teeth can affect your confidence, speech, and ability to chew properly. At Magnum Dental Clinic, Guwahati, we offer high-quality dental crowns and bridges to restore the function, strength, and appearance of your smile.

Our advanced restorative treatments are designed to look natural, feel comfortable, and last long—so you can smile confidently again.
      `,
    },

    {
      type: "image",
      images: [
        "/dental-services/crowns-bridges.webp",
        "/dental-services/crowns-and-bridges/best-dental-clinic.webp",
        "/dental-services/crowns-and-bridges/dental-clinic-near-me-guwahati.webp",
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "What Are Dental Crowns?",
      content: `
A dental crown is a tooth-shaped cap placed over a damaged, broken, or weak tooth to restore its shape, size, strength, and appearance. Crowns protect the tooth while maintaining a natural look and feel.
      `,
    },

    {
      type: "text",
      heading: "When Do You Need a Dental Crown?",
      content: `
You may need a dental crown if you have:

✔ A broken or cracked tooth  
✔ A heavily filled tooth  
✔ A root canal treated tooth  
✔ A worn-down tooth  
✔ A poorly shaped or discolored tooth

We provide natural-looking dental crowns in Guwahati using advanced, long-lasting materials.
      `,
    },

    {
      type: "text",
      heading: "What Are Dental Bridges?",
      content: `
A dental bridge is used to replace one or more missing teeth by anchoring an artificial tooth between two healthy teeth or dental implants. It literally “bridges” the gap and restores your smile.
      `,
    },

    {
      type: "text",
      heading: "Benefits of Dental Bridges",
      content: `
✔ Restores chewing and speaking ability  
✔ Prevents nearby teeth from shifting  
✔ Maintains facial structure  
✔ Improves smile aesthetics  
✔ Boosts confidence  

Our clinic specializes in custom-made dental bridges in Guwahati for a
perfect fit and natural appearance.
      `,
    },

    {
      type: "text",
      heading: "Benefits of Crowns and Bridges",
      content: `
✔ Restores natural tooth shape and function  
✔ Improves chewing efficiency  
✔ Enhances smile appearance  
✔ Protects weak teeth from further damage  
✔ Long-lasting and durable  
✔ Custom-designed for a perfect fit  

Our patients trust us for safe and reliable crowns and bridges treatment in Guwahati.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Crowns & Bridges in Guwahati?",
      content: `
✔ Experienced restorative dentists  
✔ High-quality, long-lasting materials  
✔ Personalized treatment plans  
✔ Modern, hygienic clinic setup  
✔ Affordable pricing & flexible options  

We are a trusted name for dental crowns and bridges in Guwahati.
      `,
    },

    {
      type: "text",
      heading: "Treatment Process",
      content: `
1. Consultation and Dental Examination 
2) Tooth Preparation 
3) Dental Impression and Shade Match
4) Crown/Bridge Trial 
5) Final Crown or Bridge Placement 
6) Bite Adjustment and Polishing
      `,
    },
  ],

  faqs: [
    {
      q: "Are dental crowns painful?",
      a: "The procedure is generally painless and comfortable for most patients. Local anesthesia is used (if required).",
    },
    {
      q: "How long do crowns and bridges last?",
      a: "With proper care, they can last 10–15 years or even longer.",
    },
    {
      q: "Do crowns look natural?",
      a: "Yes, modern crowns are designed to match your natural teeth in color and shape.",
    },
    {
      q: "How much do crowns and bridges cost in Guwahati?",
      a: "The cost depends on the material used. Visit us for a personalized consultation.",
    },
    {
      q: "Can I eat normally after getting a crown or bridge?",
      a: "Yes, once placed, you can eat comfortably just like with natural teeth.",
    },
  ],

  cta: {
    heading: "Book Your Crown & Bridge Consultation in Guwahati",
    description: `
Restore your smile with strong, natural-looking crowns and bridges at Magnum Dental Clinic, Guwahati.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Restoring Smiles with Precision & Care
    `,
    buttonText: "Book Crown & Bridge Consultation",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
